import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "avatar-group" }
const _hoisted_2 = { class: "avatar-group__tooltip-users custom-scroll" }
const _hoisted_3 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_VDropdown = _resolveComponent("VDropdown")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.croppedAvatarsByLength, (item, index) => {
      return _withDirectives((_openBlock(), _createBlock(_component_Avatar, {
        key: index,
        src: item.picture?.pictureUrl,
        gap: item.getInitials(),
        style: _normalizeStyle(`z-index: ${index}`),
        class: "avatar-group__item is-scale-by-hover",
        bordered: ""
      }, null, 8, ["src", "gap", "style"])), [
        [
          _directive_tooltip,
          { content: item?.username, theme: 'info-tooltip-sm' },
          void 0,
          { bottom: true }
        ]
      ])
    }), 128)),
    (_ctx.lengthOfHiddenAvatars && _ctx.showHiddenAvatarsTooltip)
      ? (_openBlock(), _createBlock(_component_VDropdown, {
          key: 0,
          theme: "info-tooltip-sm",
          placement: "bottom",
          triggers: _ctx.hiddenAvatarsTriggers,
          hideTriggers: _ctx.hiddenAvatarsTriggers,
          delay: 0,
          autoHide: true,
          style: _normalizeStyle(`z-index: ${_ctx.numberOfVisibleUsers + 1}`),
          class: "avatar-group__item",
          popperClass: "avatar-group__list-tooltip"
        }, {
          popper: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hiddenAvatars, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "avatar-group__tooltip-user"
                }, [
                  _createVNode(_component_Avatar, {
                    src: item.picture?.pictureUrl,
                    gap: item.getInitials(),
                    size: "sm",
                    class: "avatar-group__tooltip-avatar",
                    bordered: ""
                  }, null, 8, ["src", "gap"]),
                  _createElementVNode("span", null, _toDisplayString(item.fullName || item.username), 1)
                ]))
              }), 128))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "avatar is-md is-bordered avatar__length is-scale-by-hover",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, " +" + _toDisplayString(_ctx.lengthOfHiddenAvatars), 1)
          ]),
          _: 1
        }, 8, ["triggers", "hideTriggers", "style"]))
      : (_ctx.lengthOfHiddenAvatars)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            style: _normalizeStyle(`z-index: ${_ctx.numberOfVisibleUsers + 1}`),
            class: "avatar is-md is-bordered avatar-group__item avatar__length"
          }, " +" + _toDisplayString(_ctx.lengthOfHiddenAvatars), 5))
        : _createCommentVNode("", true),
    (!_ctx.croppedAvatarsByLength.length && _ctx.showEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Avatar, {
            src: null,
            class: "is-blue avatar-group__item",
            bordered: ""
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}